import gotoPageVersion from './goto-page-version';

export default (routeToCheck, user) => {
	if (
		routeToCheck &&
		routeToCheck.meta &&
		routeToCheck.meta.accessWebRoute &&
		routeToCheck.meta.configKeyId &&
		user &&
		user.PageVersions
	) {
		//value could be a single pair that's string representation of an array: "[46, 2]"
		//or an array of string pairs: ["[46, 2]", "[47, 2]""];
		let pageVersions = user.PageVersions;
		const pageVersionObj = {};

		if (!Array.isArray(user.PageVersions)) {
			pageVersions = [pageVersions];
		}

		for (let index = 0; index < pageVersions.length; index++) {
			//parse into an array
			const versionArray = JSON.parse(pageVersions[index]);

			//first element of the array is the page config id
			pageVersionObj[versionArray[0]] = versionArray[1];
		}

		const version = parseInt(pageVersionObj[routeToCheck.meta.configKeyId]);

		if (version === 1) {
			gotoPageVersion(routeToCheck);
		}
	}
};
